import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FEATCH_ROUND,
  ROUND_CANCEL,
  ROUND_CANCEL_LIST,
  ROUND_CANCEL_LOG,
  REPORT_ROUND_LOG,
  UPDATE_STATUS,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'round' })
export default class Round extends VuexModule {
  roundData = {}

  roundSelect: any = {}

  roundSelectAll: any = {}

  @Mutation
  mutateRoundData(data) {
    this.roundData = data;
  }

  @Mutation
  mutateRoundLog(data) {
    this.roundData = data;
  }

  @Action({ commit: 'mutateRoundData' })
  FetchRoundTable(params = {}) {
    return Vue.axios({
      url: BASE_URL + FEATCH_ROUND,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  RounceCancel(params = {}) {
    return Vue.axios({
      url: BASE_URL + ROUND_CANCEL,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  RounceCancelList(params = {}) {
    return Vue.axios({
      url: BASE_URL + ROUND_CANCEL_LIST,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateRoundLog' })
  FetchRoundLog(params = {}) {
    return Vue.axios({
      url: BASE_URL + ROUND_CANCEL_LOG,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateRoundLog' })
  FetchReportRoundLog(params = {}) {
    return Vue.axios({
      url: BASE_URL + REPORT_ROUND_LOG,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  RoundUpdate(params = {}) {
    return Vue.axios({
      url: BASE_URL + UPDATE_STATUS,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateRoundSelect(data: any) {
    this.roundSelect = data;
  }

  @Mutation
  mutateRoundSelectAll(data: any) {
    this.roundSelectAll = data;
  }

  @Action({ commit: 'mutateRoundSelectAll' })
  async selectAll(data) {
    return data;
  }
}
